// extracted by mini-css-extract-plugin
module.exports = {"header":"mheader_header__zErK7 headline_headline__is2WG"};